var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { class: ["quotazione", "font-weight-bold", { small: _vm.small }] },
    [_vm._v("\n  Q " + _vm._s(_vm.quotazione) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }